import React, { useEffect, useRef, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const DURATION_MS = 15 * 60 * 1000;
const STORAGE_KEY = 'psOfferDeadline';
function readDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  const parsed = stored ? Number(stored) : NaN;
  if (Number.isFinite(parsed) && parsed > Date.now()) return parsed;
  const next = Date.now() + DURATION_MS;
  window.sessionStorage.setItem(STORAGE_KEY, String(next));
  return next;
}
function format(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const minutes = String(Math.floor(total / 60)).padStart(2, '0');
  const seconds = String(total % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}
export function UrgencyCountdown() {
  const deadlineRef = useRef<number | null>(null);
  const [remaining, setRemaining] = useState<number>(DURATION_MS);
  useEffect(() => {
    deadlineRef.current = readDeadline();
    setRemaining(deadlineRef.current - Date.now());
    const interval = window.setInterval(() => {
      if (deadlineRef.current === null) return;
      setRemaining(deadlineRef.current - Date.now());
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const expired = remaining <= 0;
  return <div className="mt-4 flex flex-col items-center gap-1.5 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-center sm:flex-row sm:justify-start sm:gap-3 sm:text-left" data-id="element-160" data-mp="3u0osp4wmy39d">
      <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-rose-600" data-id="element-161" data-mp="31cj8cj9huga2">
        <ClockIcon aria-hidden="true" className="h-4 w-4" data-id="element-162" data-mp="36bm1b5c78w1o" />
        {expired ? 'Últimos minutos' : 'Tu precio de USD 17 vence en'}
      </p>
      <p aria-live="polite" aria-atomic="true" className="font-display text-2xl font-semibold leading-none tabular-nums text-plum-800" data-id="element-163" data-mp="3b4yqbgksj4uy">
        {expired ? '00:00' : format(remaining)}
      </p>
      <p className="text-xs text-plum-400 sm:ml-auto" data-id="element-164" data-mp="3lx75ca68wzxr">
        {expired ? 'Asegúralo antes de que vuelva a USD 84' : 'Después vuelve a USD 84.00'}
      </p>
    </div>;
}